// Story 11.3 — Helpers puros para el sync editor↔diagrama. Sin React/zustand.

import type { LineMapResult } from '@/components/editor/diagram/line-map';

export interface SyncState {
  /** lineNumber del cursor (1-based), o null. */
  cursorLine: number | null;
  /** Step actualmente highlighted en el diagrama. */
  highlightedStepId: string | null;
}

export const initialSyncState: SyncState = {
  cursorLine: null,
  highlightedStepId: null,
};

/**
 * Resuelve el step que contiene la línea actual usando el line map. Si el
 * map no es válido o la línea no matchea, retorna `null`.
 */
export function resolveHighlightedStep(
  cursorLine: number | null,
  lineMap: LineMapResult,
): string | null {
  if (cursorLine == null || !lineMap.ok) return null;
  return lineMap.lineToStep.get(cursorLine) ?? null;
}

/**
 * True si el step ha cambiado entre dos resoluciones (incluye null↔value).
 * Usado para decidir si el `setCenter` del diagrama debe re-disparar.
 */
export function stepChanged(prev: string | null, next: string | null): boolean {
  return prev !== next;
}

/**
 * Aplica una transición de cursor: actualiza cursorLine; recomputa
 * highlightedStepId solo si la nueva resolución es != null o el line map
 * cambió. Si el YAML está roto (lineMap.ok = false) preserva el highlight
 * previo — UX: no parpadear el highlight durante typing inválido.
 */
export function applyCursorMove(
  state: SyncState,
  cursorLine: number | null,
  lineMap: LineMapResult,
): SyncState {
  const next = resolveHighlightedStep(cursorLine, lineMap);
  // Si el lineMap es inválido (parse failure mid-typing), conservamos el
  // highlight anterior — `null` sería visual flash innecesario.
  if (!lineMap.ok && state.highlightedStepId != null) {
    return { ...state, cursorLine };
  }
  return { cursorLine, highlightedStepId: next };
}
